import { Button, Form, Input, InputNumber, Select, Table, Tabs, Transfer } from "antd";
import { filterOption, fiscalCodeField, requiredField } from "../common/common";
import { useEffect, useState } from "react";
import axiosInstance, { api } from "../common/api";
import { useNavigate } from "react-router";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

const TableItem = ({ name, options, optionKey, title, includePolicy = false }) => (
  <Form.List name={name} label="Attrezzature richieste">
    {(fields, { add, remove }) => (
      <div style={{  minHeight: 400 }}>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "top",
            marginBottom: 10,
          }}
        >
          <h3 style={{ margin: 0 }}>{title}</h3>
          <div style={{ flex: 1, textAlign: "end" }}>
            <Button onClick={() => add()} icon={<PlusOutlined />}>
              Aggiungi
            </Button>
          </div>
        </div>
        <Table
          dataSource={fields}
          tableLayout="fixed"
          pagination={false}
          scroll={{ y: 300 }}
          rowKey="name"
          columns={[
            {
              key: "item",
              title: "Elemento",
              render: (field) => (
                <Form.Item name={[field.name, optionKey]} noStyle>
                  <Select
                    options={options}
                    style={{ width: "100%" }}
                    showSearch
                    filterOption={filterOption}
                  />
                </Form.Item>
              ),
            },
            {
              key: "qty",
              title: "Q.ta minima",
              render: (field) => (
                <Form.Item name={[field.name, "minCount"]} noStyle>
                  <InputNumber min={1} controls={false} />
                </Form.Item>
              ),
            },
            includePolicy && {
              key: "policy",
              title: "Politica",
              render: (field) => (
                <Form.Item name={[field.name, "policy"]} noStyle>
                  <Select
                    showSearch
                    style={{ width: "100%" }}
                    filterOption={filterOption}
                    options={[
                      { label: "Ciascuno", value: "INDIVIDUAL" },
                      {
                        label: "Condiviso",
                        value: "ABSOLUTE",
                      },
                    ]}
                  />
                </Form.Item>
              ),
            },
            {
              key: "actions",
              render: (field) => (
                <Button type="text" icon={<DeleteOutlined />} onClick={() => remove(field.name)} />
              ),
            },
          ].filter((x) => !!x)}
        />
      </div>
    )}
  </Form.List>
);

export default function () {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [dpiTypes, setDpiTypes] = useState([]);
  const [equipmentTypes, setEquipmentTypes] = useState([]);
  const [appointmentTypes, setAppointmentTypes] = useState([]);
  const [mansions, setMansions] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);

  useEffect(() => {
    [
      { p: "equipmentType", a: setEquipmentTypes },
      { p: "mansion", a: setMansions },
      { p: "vehicleType", a: setVehicleTypes },
      { p: "appointmentType", a: setAppointmentTypes},
      { p: "dpi", a: setDpiTypes },
    ].forEach(({ p, a }) =>
      api[p]
        .list({ pageSize: 9999 })
        .then((data) => a(data.data.map((x) => ({ label: x.name, value: x.id })))),
    );
  }, []);

  const onFinish = (data) => {
    setLoading(true);
    axiosInstance
      .post("workActivity", data)
      .then(() => navigate(-1))
      .finally(() => setLoading(false));
  };

  return (
    <Form
      onFinish={onFinish}
      layout="vertical"
      autoComplete="off"
      initialValues={{ requiredEquipments: [], requiredVehicleTypes: [], requiredMansions: [] }}
    >
      <Form.Item name="name" label="Nome">
        <Input />
      </Form.Item>
      <Tabs
        items={[
          {
            key: "eq",
            label: "Attrezzature richieste",
            children: (
              <TableItem
                title="Attrezzature richieste"
                options={equipmentTypes}
                name="requiredEquipments"
                optionKey="equipmentType"
              />
            ),
          },
          {
            key: "ma",
            label: "Mansioni richieste",
            children: (
              <TableItem
                title="Mansioni richieste"
                options={mansions}
                name="requiredMansions"
                optionKey="mansion"
              />
            ),
          },
          {
            key: "ve",
            label: "Veicoli richiesti",
            children: (
              <TableItem
                title="Veicoli richiesti"
                options={vehicleTypes}
                name="requiredVehicles"
                optionKey="vehicleType"
              />
            ),
          },
          {
            key: "dpi",
            label: "DPI richiesti",
            children: (
              <TableItem
                title="DPI richiesti"
                options={dpiTypes}
                name="requiredDpis"
                includePolicy
                optionKey="dpi"
              />
            ),
          },
          {
            key: "nom",
            label: "Nomine richieste",
            children: (
              <TableItem
                title="Nomine richieste"
                options={appointmentTypes}
                name="requiredAppointments"
                optionKey="appointmentType"
              />
            ),
          },
        ]}
      />
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Conferma
        </Button>
      </Form.Item>
    </Form>
  );
}
